import React from "react";
import QrCodeGenerator from "./QrCodeGenerator";
import { Base } from "../../widgets/Base/Base";
import {
  getLoginInformation,
  getSessionInformation,
  getRefusal,
  getAttemptError,
} from "../../selectors/authentication";
import * as authenticationActions from "../../actions/authentication";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LoginRefusal from "../../widgets/LoginRefusal";

import Background1 from "../../utils/styles/images/showroom-background-2.jpg";
import Background2 from "../../utils/styles/images/showroom-background-3.jpg";
import AfterLogin from "./AfterLogin";
import "../../utils/styles/Mire.css";

// QR login screen: a refusal replaces everything (with "Recommencer", which also regenerates the
// QR since the generator remounts with a new session id); a pending challenge shows the response
// form; otherwise the QR pairing step.
const Component = ({ actions, loginInformation, sessionInformation, refusal, attemptError }) => {
  const subTitle1 = "vous invite à\nvous identifier";
  const subTitle2 = "vous invite à générer\nvotre code d'accès";

  let content;
  if (refusal) {
    content = (
      <div id="mire">
        <div className="mireContainer">
          <LoginRefusal refusal={refusal} onRestart={actions.resetAuth} />
        </div>
      </div>
    );
  } else if (loginInformation && loginInformation.isPublicPass === false) {
    content = (
      <div id="mire">
        <div className="mireContainer">
          <AfterLogin
            actions={actions}
            loginInformation={loginInformation}
            attemptError={attemptError}
            sessionInformation={sessionInformation}
          />
        </div>
      </div>
    );
  } else {
    // Public pass in progress, or not paired yet: stay on the QR step (and its state).
    content = <QrCodeGenerator actions={actions} />;
  }

  return (
    <Base
      title="Votre esprit d'analyse"
      subTitle={!loginInformation ? subTitle1 : subTitle2}
      backgroundImage={!loginInformation ? Background1 : Background2}
    >
      {content}
    </Base>
  );
};

const actions = {
  getSessionDetails: authenticationActions.getSessionDetails,
  checkChallenge: authenticationActions.checkChallenge,
  setRefusal: authenticationActions.setRefusal,
  resetAuth: authenticationActions.resetAuth,
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

const mapStateToProps = createStructuredSelector({
  loginInformation: getLoginInformation,
  sessionInformation: getSessionInformation,
  refusal: getRefusal,
  attemptError: getAttemptError,
});

export const enhance = connect(mapStateToProps, mapDispatchToProps);

export default enhance(Component);
